import graphListJson from "@/assets/graph-sort-items.json";

const GraphListUtils = {
  convertJsonToGraphListObject() {
    const graphList = graphListJson;

    const json_str = JSON.stringify(graphList.list[0]);
    return JSON.parse(json_str);
  }
};

export default GraphListUtils;
